var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import uniqBy from 'lodash/uniqBy';
import { AdFetchingStatus } from '@ads/constants';
import { getFWAIAds } from '@ads/utils/adTag';
import { Api_AdPlacementType } from '@core/api';
export const useAdInFeed = (props) => {
    const { appContext, params } = props;
    const adUnit = useMemo(() => {
        var _a, _b;
        return (_b = (_a = appContext.adConfig) === null || _a === void 0 ? void 0 : _a.placements) === null || _b === void 0 ? void 0 : _b.find((placement) => placement.placement_type === Api_AdPlacementType.RM_INFEED ||
            placement.placement_type === Api_AdPlacementType.OUTSTREAM);
    }, [appContext]);
    const [state, setState] = useState({
        loading: !!adUnit,
        adVideos: [],
        positions: [],
    });
    const loadAds = useCallback((adUnit) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getFWAIAds(adUnit.ad_tags[0], params);
        if (response.status === AdFetchingStatus.OK) {
            setState((state) => ({
                loading: false,
                adVideos: uniqBy(state.adVideos.concat(response.ads), (video) => video.encoded_id),
                positions: adUnit.positions || [0],
            }));
        }
        else {
            setState((state) => (Object.assign(Object.assign({}, state), { loading: false })));
        }
        return response;
    }), [adUnit, params, setState]);
    useEffect(() => {
        if (!state.loading) {
            return;
        }
        if (!adUnit) {
            setState((state) => (Object.assign(Object.assign({}, state), { loading: false })));
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield loadAds(adUnit);
            // if we are in outstream player and get only one ad from first call, we prefetch next ad with small delay
            if (adUnit.placement_type === Api_AdPlacementType.OUTSTREAM &&
                response.status === AdFetchingStatus.OK &&
                response.ads.length === 1) {
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield loadAds(adUnit);
                }), 3000);
            }
        }))();
    }, [adUnit, state.loading, params.vast_attrs]);
    const loadMore = useCallback(() => {
        if (adUnit && adUnit.placement_type === Api_AdPlacementType.OUTSTREAM) {
            loadAds(adUnit);
        }
    }, [adUnit, loadAds]);
    return useMemo(() => (Object.assign(Object.assign({}, state), { actions: {
            loadMore,
        } })), [state, loadMore]);
};
